import React, { useEffect, useContext, memo } from 'react';
import getComponent from 'components/FORM_MAP';
import { trackWizardView } from 'utils/trackingFunctions';
import GlobalContext from 'hooks/contexts/GlobalContext';
import { initTrustedForm, initJornaya } from 'utils/thirdPartyScripts';
import { Questionnaire as QuestionnaireType } from 'types';

// eslint-disable-next-line react/display-name
const LeadIdField = memo(() => (
  <input id="leadid_token" name="universal_leadid" type="hidden" value="" />
));

export default function Questionnaire(
  props: QuestionnaireType
): React.JSX.Element | null {
  const {
    windowSize: { currentBreakpoint },
    sessionInfo: { pageViewId },
  } = useContext(GlobalContext);

  const {
    component,
    mobileComponent,
    isFullPage = false,
    disableTrustedForm,
    ...questionnaireData
  } = props;

  const formComponent =
    currentBreakpoint === 'desktop' ? component : mobileComponent;

  const Form = getComponent(formComponent);

  useEffect(() => {
    if (!disableTrustedForm) {
      initTrustedForm();
    }

    initJornaya();
  }, []);

  useEffect(() => {
    pageViewId && trackWizardView(props.schoolCode, questionnaireData.variant);
  }, [questionnaireData.variant, pageViewId]);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
  };

  return (
    <form className="questionnaire" onSubmit={onSubmit}>
      <Form {...questionnaireData} isFullPage={isFullPage} />
      <LeadIdField />
    </form>
  );
}
